(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('team', team);

    /* @ngInject */
    function team() {
        var directive = {
            bindToController: true,
            templateUrl: 'team.tpl',
            controller: teamController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }

    }

    /* @ngInject */
    function teamController () {
    }
})();